module.exports = __webpack_public_path__ + "img/partner-3.9a98cef2.png";